import { apiTypes } from 'shared/consts/handbooksApiTypes';


const config = {
  schema: 'cat',
  table: 'temp_sensor',
  apiType: apiTypes.REPORT_API,
  fields: [
    {
      name: 'id',
      index: true,
    },
    {
      name: 'vehicle_id',
      required: false,
    },
    {
      name: 'user_serial_number',
      required: false,
    },
    {
      name: 'sensor_type_id',
      required: false,
    },
  ],
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
};

export default config;
